import type { Manifest } from "../data/types";

export interface CameraPicker {
  /** Update the active highlight without firing the callback. */
  setActive(camId: string | null): void;
}

/**
 * Vertical grid of camera-id buttons. Clicking one enters snap mode for that
 * camera; the "free look" button in the bottom bar exits to free-look.
 */
export function setupCameraPicker(
  manifest: Manifest,
  onPick: (camId: string) => void,
  onFreeLook: () => void,
): CameraPicker {
  const root = document.getElementById("cam-picker") as HTMLDivElement;
  root.innerHTML = "";
  const btnByCam = new Map<string, HTMLButtonElement>();

  for (const v of manifest.videos) {
    const b = document.createElement("button");
    b.textContent = v.cam;
    b.title = `${v.cam} — ${v.fps.toFixed(1)} fps, ${v.duration_s.toFixed(1)}s`;
    b.addEventListener("click", () => onPick(v.cam));
    root.appendChild(b);
    btnByCam.set(v.cam, b);
  }

  const freeBtn = document.getElementById("free-look") as HTMLButtonElement;
  freeBtn.addEventListener("click", onFreeLook);

  function setActive(camId: string | null): void {
    for (const [id, b] of btnByCam) {
      b.classList.toggle("active", id === camId);
    }
    freeBtn.classList.toggle("on", camId === null);
  }

  return { setActive };
}
